import { render, staticRenderFns } from "./CustomerStatsList.vue?vue&type=template&id=71604ea2&"
import script from "./CustomerStatsList.vue?vue&type=script&lang=js&"
export * from "./CustomerStatsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports